var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.247 7.98c-.452-.357-.99-.843-1.97-.964-.921-.122-1.859.494-2.492.902-.634.408-1.832 1.606-2.327 1.97-.495.365-1.762.704-3.802 1.928S8.613 18.179 8.613 18.179l2.083.025-9.288 4.783h.929L1 24.003s1.18.313 2.17-.312v.287s11.06-4.357 13.195-3.229l-1.302.382c.112 0 2.213.14 2.213.14a2.98 2.98 0 0 0 1.337 2.152c1.267.833 1.293 1.293 1.293 1.293s-.66.27-.66.608c0 0 .973-.295 1.875-.27a7.178 7.178 0 0 1 1.694.27s-.07-.365-.946-.608c-.877-.243-1.745-1.198-2.17-1.719a2.43 2.43 0 0 1-.356-2.378c.304-.79 1.363-1.224 3.55-2.352 2.579-1.337 3.169-2.327 3.533-3.1.365-.772.903-2.308 1.207-3.029.382-.929.85-1.424 1.241-1.719.39-.295 2.127-.946 2.127-.946s-1.328-1.154-1.753-1.493z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/KSM.ce63ece8029a4034e2d6157a7e7ad095.svg";
export { ForwardRef as ReactComponent };